import { Request } from "./HttpService";

export const ReportsService = {
  getAll: function () {
    return Request("vitae/BaseReport/global", "GET");
  },
  get: function () {
    return Request("vitae/BaseReport", "GET");
  }
};
